import i18n from 'i18next';
import {initReactI18next} from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import en from '../locales/en.json';
import nl from '../locales/nl.json';

const langDetectorOptions = {
  // order and from where user language should be detected
  order: ['path', 'navigator'],

  // keys or params to lookup language from
  lookupCookie: 'locale',
  lookupLocalStorage: 'locale',

  // cache user language on
  caches: ['localStorage', 'cookie'],
  excludeCacheFor: ['cimode'], // languages to not persist (cookie, localStorage)

  // only detect languages that are in the whitelist
  checkWhitelist: true,
};

i18n
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    lng: 'en',
    resources: {
      en: {
        translation: en
      },
    },
    fallbackLng: 'en',
    debug: true,
    whitelist: ['en', 'nl'],
    detection: langDetectorOptions,
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    }
  });
export default i18n;
